// via https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#safely_detecting_option_support

let supportsPassiveEvents = false;

try {
    const options = {
        get passive() {
            // This function will be called when the browser
            // attempts to access the passive property.
            supportsPassiveEvents = true;
            return false;
        },
    };

    window.addEventListener("test", null, options);
    window.removeEventListener(
        "test" as keyof WindowEventMap,
        null,
        options as EventListenerOptions
    );
} catch {
    supportsPassiveEvents = false;
}

export { supportsPassiveEvents };
